import type { ComponentType, SVGProps } from 'react';

import {
  IconContacts,
  IconDashboard,
  IconInteractions,
  IconLock,
  IconSettings,
} from '../ui/icons.js';

/**
 * The sidebar's routes (S03).
 *
 * `queueBadge` marks the one entry that carries a live count. The pages
 * themselves arrive with their phases; the shell exists now so navigation,
 * identity and the connection indicator are real from P1 onwards.
 */
export interface NavItem {
  to: string;
  label: string;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  /** Whether this entry shows the live queue count. */
  queueBadge?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Dashboard', Icon: IconDashboard },
  {
    to: '/contacts',
    label: 'Contacts & Queue',
    Icon: IconContacts,
    queueBadge: true,
  },
  { to: '/interactions', label: 'Interactions', Icon: IconInteractions },
  { to: '/agents', label: 'Agent Configuration', Icon: IconSettings },
  // Access has no counterpart in the mock — it is S02's addition — so it borrows
  // the mock's own lock rather than introducing a shape from a different set.
  { to: '/access', label: 'Access', Icon: IconLock },
];

/** Per-route title and subtitle for the top bar. */
export const ROUTE_TITLES: Record<string, [string, string]> = {
  '/': ['Dashboard', 'Outbound call activity overview'],
  '/contacts': ['Contacts & Queue', 'Imported contacts — queue & schedule calls'],
  '/interactions': ['Interactions', 'Analyzed call results & lead outcomes'],
  '/agents': ['Agent Configuration', "Edit your agent's details & instructions"],
  '/access': ['Access', 'Who may sign in to this console'],
};
